module.exports = __webpack_public_path__ + "static/6-4afb56c33db7e47182d96c495ca8fac8.jpg";